<template>
	<a
		:class="[
			'cbre-c-ctaLink',
			{
				'cbre-c-ctaLink--white': white,
				'cbre-is-disabled': disabled,
				'cbre-c-ctaLink--externalIcon': external,
			},
		]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink ? parsedLink.target : null"
		:aria-disabled="disabled ? 'true' : 'false'"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		@click="checkEmpty"
		data-auto="pagecard-cta-link"
		ref="site_button"
	>
		<slot>{{
			button_label ? button_label : parsedLink ? parsedLink.title : ''
		}}</slot>
		<span v-if="external" class="cbre-c-ctaLink--externalIcon"></span>
	</a>
</template>

<script>
export default {
	name: 'PrimaryButtonAlt',
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},
	props: {
		link: {},
		label: {},
		is_hovered: {
			type: Boolean,
			default: false,
		},
		target: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
		white: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		external: { type: Boolean, default: false },
	},
	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},
	watch: {
		link() {
			this.button_link = this.link;
		},
	},
	methods: {
		checkEmpty(e) {
			if (this.button_link && this.button_link.url === '#') {
				e.preventDefault();
			}
		},
	},
	components: {},
	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.cbre-c-ctaLink {
	display: inline-flex;
	padding: 16px 24px 12px;
	border-radius: 30px;
	text-decoration: none;
	/* height: 60px; */
	display: inline-flex;
	justify-content: flex-start;
	/* align-items: center; */
	transition: 0.2s ease all;
	color: var(--fpe-blue);
	border: 1px solid var(--white);
	overflow: hidden;
	min-width: auto;
	position: relative;
	z-index: 1;
	/* box-shadow: 0px -0px 0 var(--fpe-blue); */
	font: normal normal 300 16px/16px var(--primary-font-family);
	padding-inline-start: 48px;
	transition: all 0.4s cubic-bezier(0.75, 0.02, 0.5, 1);
	position: relative;
	display: inline-block;
	color: var(--fpe-blue);
	text-decoration: none;

	&::before {
		content: '';
		position: absolute;
		inset-block-start: 50%;
		inset-inline-start: 0;
		display: inline-block;
		width: 40px;
		height: 1px;
		background: var(--fpe-blue);
		transition: width 0.4s cubic-bezier(0.75, 0.02, 0.5, 1);
	}

	&::after {
		transition: all 0.4s cubic-bezier(0.75, 0.02, 0.5, 1);
		content: '';
		position: absolute;
		inset-block-start: 16px;
		inset-inline-end: -0.5em;
		display: inline-block;
		width: 0;
		height: 17px;
		background-size: 20px;
		background-repeat: no-repeat;
		background-position: right center;
		content: '\02192';
		pointer-events: none;
		overflow: hidden;
	}

	&:hover,
	&:active {
		padding-inline-end: 48px;
		padding-inline-start: 24px;
		background: var(--white);
		transition: all 0.4s cubic-bezier(0.75, 0.02, 0.5, 1);
		cursor: pointer;
		/* box-shadow: 1px -1px 0 var(--fpe-blue); */

		&::before {
			width: 16px;
		}

		&::after {
			inset-inline-end: 0;
			width: 42px;
		}
	}

	&--white {
		color: var(--fpe-light-grey);
	}

	&.cbre-is-disabled {
		pointer-events: none;
		opacity: 0.4;
	}

	&[target='_blank'] {
		position: relative;
		padding-inline-end: 54px;

		.cbre-c-ctaLink--externalIcon {
			display: inline-block;
			width: 0.9em;
			height: 0.9em;
			margin-inline-start: 8px;

			&:before,
			&:after {
				transition: opacity 0.25s cubic-bezier(0.75, 0.02, 0.5, 1);
				content: '';
				display: inline-block;
				position: absolute;
				inset-block-start: 50%;
				transform: translateY(-50%);
				width: 0.9em;
				height: 0.9em;
			}

			&:before {
				background-size: 100%;
				background-repeat: no-repeat;
				background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCA0MSAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTQwLjcwOSA4LjQ0MzM2TDMzLjMwMTggMTYuODg1N0wzMS43OTg4IDE1LjU2NzRMMzcuMTcwOSA5LjQ0MzM2SDBWNy40NDMzNkgzNy4xNzE5TDMxLjc5ODggMS4zMTgzNkwzMy4zMDE4IDBMNDAuNzA5IDguNDQzMzZaIgogICAgZmlsbD0iIzUzNjI4QiIgLz4KPC9zdmc+CiAg');
			}
		}
	}
}

.cbre-c-ctaLink--externalIcon {
	position: relative;
}

[dir='rtl'] .cbre-c-ctaLink::after {
	transform: rotate(180deg);
}
</style> 


// WEBPACK FOOTER //
// resources/assets/scripts/vue/PrimaryButtonAlt.vue